<template>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentcolor">
    <path
      d="M15 4L13.6 5.4L15.2 7H11C10 7 9.2 7.7 9 8.7C8.9 9.6 8.4 10.4 7.7 11C7.2 11.5 6.5 11.8 5.7 11.9C4.7 12.1 4 12.9 4 13.9V14.9V20H6V13.9C7.1 13.7 8.2 13.2 9 12.5C10.1 11.6 10.7 10.4 11 9H15.2L13.6 10.6L15 12L19 8L15 4Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
